let sorters = [];
sorters.lastloggedin = (courses) =>
  courses.sort((a, b) => b.lastLoggedIn - a.lastLoggedIn);
sorters.title = (courses) =>
  courses.sort((a, b) => a.title.localeCompare(b.title));
sorters.createddate = (courses) => {
  return courses.sort((a, b) => {
    const dateA = new Date(a.createdDate);
    const dateB = new Date(b.createdDate);
    return dateB - dateA;
  });
};

export { sorters };
